import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { TotalCareIqConfig } from './totalcareiq.types';
import { HttpClient } from '@angular/common/http';

export const totalCareIqResolver: ResolveFn<TotalCareIqConfig | null> = (route) => {

  return inject(HttpClient).get<TotalCareIqConfig>('totalcareiq');
};
